import React, {Component} from "react";
import Carousel from "../../../assets/js/carousel";
import ImageLoading from "../../components/ImageLoading";
import ImageLoader from 'react-imageloader';

//cash images
import baranovichi_1 from "./../../../assets/images/pps/baranovichi/1.jpg";
import baranovichi_2 from "./../../../assets/images/pps/baranovichi/2.jpg";
import baranovichi_3 from "./../../../assets/images/pps/baranovichi/3.jpg";
import baranovichi_4 from "./../../../assets/images/pps/baranovichi/4.jpg";
import baranovichi_5 from "./../../../assets/images/pps/baranovichi/5.jpg";

import bobruisk_1 from "./../../../assets/images/pps/bobruisk/1.jpg";
import bobruisk_2 from "./../../../assets/images/pps/bobruisk/2.jpg";
import bobruisk_3 from "./../../../assets/images/pps/bobruisk/3.jpg";
import bobruisk_4 from "./../../../assets/images/pps/bobruisk/4.jpg";
import bobruisk_5 from "./../../../assets/images/pps/bobruisk/5.jpg";

import brest_1 from "./../../../assets/images/pps/brest/1.JPG";
import brest_2 from "./../../../assets/images/pps/brest/2.JPG";
import brest_3 from "./../../../assets/images/pps/brest/3.JPG";
import brest_4 from "./../../../assets/images/pps/brest/4.JPG";


import vitebsk_1 from "./../../../assets/images/pps/vitebsk/1.jpg";
import vitebsk_2 from "./../../../assets/images/pps/vitebsk/2.jpg";
import vitebsk_3 from "./../../../assets/images/pps/vitebsk/3.jpg";
import vitebsk_4 from "./../../../assets/images/pps/vitebsk/4.jpg";
import vitebsk_5 from "./../../../assets/images/pps/vitebsk/5.jpg";

import gomel_1 from "./../../../assets/images/pps/gomel/1.JPG";
import gomel_2 from "./../../../assets/images/pps/gomel/2.JPG";
import gomel_3 from "./../../../assets/images/pps/gomel/3.JPG";
import gomel_4 from "./../../../assets/images/pps/gomel/4.JPG";

import grodno_1 from "./../../../assets/images/pps/grodno/1.jpg";
import grodno_2 from "./../../../assets/images/pps/grodno/2.jpg";
import grodno_3 from "./../../../assets/images/pps/grodno/3.jpg";
import grodno_4 from "./../../../assets/images/pps/grodno/4.jpg";

import minsk_1 from "./../../../assets/images/pps/minsk/1.jpg";
import minsk_2 from "./../../../assets/images/pps/minsk/2.jpg";
import minsk_3 from "./../../../assets/images/pps/minsk/3.jpg";
import minsk_4 from "./../../../assets/images/pps/minsk/4.jpg";
import minsk_5 from "./../../../assets/images/pps/minsk/5.jpg";
import minsk_6 from "./../../../assets/images/pps/minsk/6.jpg";
import minsk_7 from "./../../../assets/images/pps/minsk/7.jpg";

import mozyr_1 from "./../../../assets/images/pps/mozyr/1.jpg";
import mozyr_2 from "./../../../assets/images/pps/mozyr/2.jpg";
import mozyr_3 from "./../../../assets/images/pps/mozyr/3.jpg";
import mozyr_4 from "./../../../assets/images/pps/mozyr/4.jpg";
import mozyr_5 from "./../../../assets/images/pps/mozyr/5.jpg";

import mogilev_1 from "./../../../assets/images/pps/mogilev/1.jpg";
import mogilev_2 from "./../../../assets/images/pps/mogilev/2.jpg";
import mogilev_3 from "./../../../assets/images/pps/mogilev/3.jpg";
import mogilev_4 from "./../../../assets/images/pps/mogilev/4.jpg";

import novopolotsk_1 from "./../../../assets/images/pps/novopolotsk/1.jpg";
import novopolotsk_2 from "./../../../assets/images/pps/novopolotsk/2.jpg";
import novopolotsk_3 from "./../../../assets/images/pps/novopolotsk/3.jpg";
import novopolotsk_4 from "./../../../assets/images/pps/novopolotsk/4.jpg";
import novopolotsk_5 from "./../../../assets/images/pps/novopolotsk/5.jpg";


class Cashes extends Component {
	state = {
		activeTab : 0
	};

	cashes = [
		{
			city        : 'Барановичи',
			address     : 'ул. Гагарина д. 2',
			workingTime : '11:00 - 22:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqCX~LA',
			images      : [baranovichi_1, baranovichi_2, baranovichi_3, baranovichi_4, baranovichi_5]
		},
		{
			city        : 'Бобруйск',
			address     : 'ул. Ульяновская д. 70Б',
			workingTime : '11:00 - 22:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqGXB3A',
			images      : [bobruisk_1, bobruisk_2, bobruisk_3, bobruisk_4, bobruisk_5]
		},
		{
			city        : 'Брест',
			address     : 'ул. Дзержинского, д. 50, к. 15',
			workingTime : '11:00 - 22:00, перерыв 15:00 - 15:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqKgO2C',
			images      : [brest_1, brest_2, brest_3, brest_4]
		},
		{
			city        : 'Витебск',
			address     : 'ул. Замковая, 5/2',
			workingTime : '11:00 - 24:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBuAFZchpC',
			images      : [vitebsk_1, vitebsk_2, vitebsk_3, vitebsk_4, vitebsk_5]
		},
		{
			city        : 'Гомель',
			address     : 'ул. Красноармейская, д. 7, помещение № 7',
			workingTime : '11:00 - 22:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqOtZGD',
			images      : [gomel_1, gomel_2, gomel_3, gomel_4]
		},
		{
			city        : 'Гродно',
			address     : 'пр. Клецкова, д. 21б-2, часть № 2, помещение № 23',
			workingTime : '11:00 - 22:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqSTDWA',
			images      : [grodno_1, grodno_2, grodno_3, grodno_4]
		},
		{
			city        : 'Минск',
			address     : 'пр-т Независимости, 179А (здание ТЦ "Спектр")',
			workingTime : '10:00 - 22:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqDXGpC',
			images      : [minsk_1, minsk_2, minsk_3, minsk_4, minsk_5, minsk_6, minsk_7]
		},
		{
			city        : 'Мозырь',
			address     : 'ул. Пролетарская, 81',
			workingTime : '11:00 - 22:00, перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqLEPoD',
			images      : [mozyr_1, mozyr_2, mozyr_3, mozyr_4, mozyr_5]
		},
		{
			city        : 'Могилев',
			address     : 'пер. Пожарный 11, 2-й этаж',
			workingTime : '11:00 - 22:00; перерыв 17:00 - 17:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqFxB8C',
			images      : [mogilev_1, mogilev_2, mogilev_3, mogilev_4]
		},
		{
			city        : 'Новополоцк',
			address     : 'ул.Молодежная, 169/1-1',
			workingTime : '11:00 - 22:00; перерыв 16:00 - 16:30',
			dayOff      : 'Без выходных',
			mapLink     : 'https://yandex.by/map-widget/v1/-/CBeKqPtZWC',
			images      : [novopolotsk_1, novopolotsk_2, novopolotsk_3, novopolotsk_4, novopolotsk_5]
		}
	];

	setActiveTab(index) {
		this.setState({
			activeTab : index
		});
	}

	componentWillMount() {
		Carousel.myCarousel('.cashes-carousel');
	}

	componentWillReceiveProps(nextProps) {

	}

	preloader() {
		return <ImageLoading/>;
	}

	render() {

		return (
			<div className="page">
				<div className="page__title">Пункты приема ставок</div>
				<div className="page__data">
					<div className="cashes">
						<div className="cashes__top">
							<div className="tabs">
								<ul>
									{this.cashes.map((cash, index) =>
										<li key={index}
										    className={`${this.state.activeTab === index && 'active'}`}
										    onClick={this.setActiveTab.bind(this, index)}>{cash.city}</li>)}
								</ul>
							</div>
						</div>

						{this.cashes.map((cash, index) =>
							<div key={index} className={`tabs__tab ${index === this.state.activeTab && 'show'}`}>
								<div className="cashes__address">
									<div className="cashes__address-left">
										<div className="cl-gray">Адрес</div>
										<div>{cash.address}</div>
									</div>
									<div className="cashes__address-right">
										<div className="cl-gray">Время работы</div>
										<div>{cash.workingTime}</div>
										<div>{cash.dayOff}</div>
									</div>
								</div>
								<div className="cashes__map">
									{index === this.state.activeTab &&
									<iframe src={cash.mapLink} width="750" height="260" frameBorder={0}></iframe>}
								</div>

								<div className="cashes__photos carousel">
									<div className="carousel__prev"><i className="fas fa-chevron-left"></i></div>

									<div className="cashes-carousel">
										{cash.images.map((image, index) =>
											<div key={index} className="carousel-element">
												{/*<img src={image}/>*/}
												<ImageLoader src={image} preloader={this.preloader}/>
											</div>
										)}
									</div>

									<div className="carousel__next">
										<i className="fas fa-chevron-right"></i>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Cashes;


// WEBPACK FOOTER //
// ./src/app/pages/Cashes/Cashes.js